
// import React, { useState, useEffect } from 'react';
// import { Plus, Trash2, AlertCircle } from 'lucide-react';
// import styles from './InputComponents.module.css';

// const TableInput = ({ question, value, onUpdate, error, isSubmitted, data, shouldShow }) => {
//     const [rows, setRows] = useState([]);
//     const [rowErrors, setRowErrors] = useState({});

//     useEffect(() => {
//         if (value && Array.isArray(value)) {
//             setRows(value);
//         } else {
//             setRows([]);
//         }
//     }, [value]);

//     const addRow = () => {
//         const newRow = {};
//         question.columns.forEach(col => {
//             newRow[col.id] = '';
//         });
//         const newRows = [...rows, newRow];
//         setRows(newRows);
//         onUpdate({ [question.id]: newRows });
//     };

//     const removeRow = (index) => {
//         const newRows = rows.filter((_, i) => i !== index);
//         setRows(newRows);
//         onUpdate({ [question.id]: newRows });

//         const newErrors = { ...rowErrors };
//         delete newErrors[index];
//         setRowErrors(newErrors);
//     };

//     const updateCell = (rowIndex, columnId, cellValue) => {
//         const newRows = [...rows];
//         newRows[rowIndex][columnId] = cellValue;
//         setRows(newRows);
//         onUpdate({ [question.id]: newRows });

//         if (rowErrors[rowIndex]?.[columnId]) {
//             const newErrors = { ...rowErrors };
//             delete newErrors[rowIndex][columnId];
//             setRowErrors(newErrors);
//         }
//     };

//     const validateRow = (row, rowIndex) => {
//         const errors = {};
//         let hasError = false;

//         question.columns.forEach(column => {
//             const value = row[column.id];
//             const isEmpty = value === undefined || value === null || value === '';

//             if (column.required && isEmpty) {
//                 errors[column.id] = 'Required';
//                 hasError = true;
//             }

//             if (column.showIf) {
//                 const { field: conditionField, value: conditionValue } = column.showIf;
//                 const actualValue = row[conditionField];
//                 const shouldShowField = actualValue === conditionValue;

//                 if (shouldShowField && column.required && isEmpty) {
//                     errors[column.id] = 'Required';
//                     hasError = true;
//                 }
//             }
//         });

//         return { errors, hasError };
//     };

//     const shouldShowColumn = (column, row) => {
//         if (!column.showIf) return true;

//         const { field: conditionField, value: conditionValue } = column.showIf;
//         const actualValue = row[conditionField];

//         return actualValue === conditionValue;
//     };

//     const renderCell = (row, column, rowIndex) => {
//         const cellValue = row[column.id] || '';
//         const cellError = rowErrors[rowIndex]?.[column.id];
//         const isVisible = shouldShowColumn(column, row);

//         if (!isVisible) return null;

//         switch (column.type) {
//             case 'select':
//                 return (
//                     <td key={column.id} className={styles.tableCell}>
//                         <select
//                             value={cellValue}
//                             onChange={(e) => updateCell(rowIndex, column.id, e.target.value)}
//                             className={`${styles.selectInput} ${cellError ? styles.inputError : ''}`}
//                             disabled={isSubmitted}
//                         >
//                             <option value="">Select...</option>
//                             {column.options.map((option, idx) => (
//                                 <option key={idx} value={option}>
//                                     {option}
//                                 </option>
//                             ))}
//                         </select>
//                         {cellError && (
//                             <span className={styles.cellError}>
//                                 <AlertCircle size={12} />
//                             </span>
//                         )}
//                     </td>
//                 );

//             case 'number':
//                 return (
//                     <td key={column.id} className={styles.tableCell}>
//                         <input
//                             type="text"
//                             inputMode="numeric"
//                             value={cellValue}
//                             onChange={(e) => {
//                                 const value = e.target.value.replace(/\D/g, '');
//                                 updateCell(rowIndex, column.id, value);
//                             }}
//                             className={`${styles.textInput} ${cellError ? styles.inputError : ''}`}
//                             disabled={isSubmitted}
//                             placeholder={column.label}
//                         />
//                         {cellError && (
//                             <span className={styles.cellError}>
//                                 <AlertCircle size={12} />
//                             </span>
//                         )}
//                     </td>
//                 );

//             case 'text':
//             default:
//                 return (
//                     <td key={column.id} className={styles.tableCell}>
//                         <input
//                             type="text"
//                             value={cellValue}
//                             onChange={(e) => updateCell(rowIndex, column.id, e.target.value)}
//                             className={`${styles.textInput} ${cellError ? styles.inputError : ''}`}
//                             disabled={isSubmitted}
//                             placeholder={column.label}
//                         />
//                         {cellError && (
//                             <span className={styles.cellError}>
//                                 <AlertCircle size={12} />
//                             </span>
//                         )}
//                     </td>
//                 );
//         }
//     };

//     const getVisibleColumns = (row) => {
//         return question.columns.filter(column => shouldShowColumn(column, row));
//     };

//     if (!shouldShow) return null;

//     return (
//         <div className={styles.tableWrapper}>
//             <div className={styles.tableHeader}>
//                 <label className={styles.tableLabel}>
//                     {question.label}
//                     {question.required && <span className={styles.required}>*</span>}
//                 </label>
//                 {!isSubmitted && (
//                     <button
//                         type="button"
//                         onClick={addRow}
//                         className={styles.addButton}
//                         disabled={isSubmitted}
//                     >
//                         <Plus size={16} />
//                         Add Row
//                     </button>
//                 )}
//             </div>

//             {rows.length > 0 && (
//                 <div className={styles.tableContainer}>
//                     <table className={styles.table}>
//                         <thead>
//                             <tr>
//                                 {question.columns.map((column, idx) => (
//                                     <th key={idx} className={styles.tableHeaderCell}>
//                                         {column.label}
//                                         {column.required && <span className={styles.required}>*</span>}
//                                     </th>
//                                 ))}
//                                 {!isSubmitted && (
//                                     <th className={styles.tableHeaderCell}>Actions</th>
//                                 )}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {rows.map((row, rowIndex) => (
//                                 <tr key={rowIndex} className={styles.tableRow}>
//                                     {question.columns.map((column) => renderCell(row, column, rowIndex))}
//                                     {!isSubmitted && (
//                                         <td className={styles.tableCell}>
//                                             <button
//                                                 type="button"
//                                                 onClick={() => removeRow(rowIndex)}
//                                                 className={styles.deleteButton}
//                                                 disabled={isSubmitted}
//                                                 title="Remove row"
//                                             >
//                                                 <Trash2 size={16} />
//                                             </button>
//                                         </td>
//                                     )}
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {rows.length === 0 && (
//                 <div className={styles.emptyState}>
//                     <p>No medications added yet. Click "Add Row" to add a medication.</p>
//                 </div>
//             )}

//             {error && (
//                 <span className={styles.errorMessage}>
//                     <AlertCircle size={16} />
//                     {error}
//                 </span>
//             )}
//         </div>
//     );
// };

// export default TableInput;

import React, { useState, useEffect } from 'react';
import { Plus, Trash2, AlertCircle } from 'lucide-react';
import styles from './InputComponents.module.css';
import DateInput from './DateInput';
import { formatDate } from '../../../../utils/dateFormatter';

const TableInput = ({ question, value, onUpdate, error, isSubmitted, data, shouldShow, disabled = false }) => {
    const [rows, setRows] = useState([]);
    const [rowErrors, setRowErrors] = useState({});
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteRowIndex, setDeleteRowIndex] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const isFormDisabled = disabled;

    useEffect(() => {
        if (value && Array.isArray(value) && value.length > 0) {
            setRows(value);
            setInitialized(true);
        } else if (shouldShow && !initialized) {
            const defaultRow = {};
            question.columns.forEach(col => {
                if (col.id === 'PCMMDCS') {
                    defaultRow[col.id] = 'Antihyperglycemic';
                } else {
                    defaultRow[col.id] = '';
                }
            });
            setRows([defaultRow]);
            onUpdate({ [question.id]: [defaultRow] });
            setInitialized(true);
        }
    }, [value, shouldShow, initialized]);

    const addRow = () => {
        const newRow = {};
        question.columns.forEach(col => {
            if (col.id === 'PCMMDCS') {
                newRow[col.id] = 'Antihyperglycemic';
            } else {
                newRow[col.id] = '';
            }
        });
        const newRows = [...rows, newRow];
        setRows(newRows);
        onUpdate({ [question.id]: newRows });
    };

    const handleDeleteClick = (index) => {
        setDeleteRowIndex(index);
        setShowDeleteConfirm(true);
    };

    const confirmDelete = () => {
        if (deleteRowIndex !== null) {
            const newRows = rows.filter((_, i) => i !== deleteRowIndex);
            setRows(newRows);
            onUpdate({ [question.id]: newRows });

            const newErrors = { ...rowErrors };
            delete newErrors[deleteRowIndex];
            setRowErrors(newErrors);
        }
        setShowDeleteConfirm(false);
        setDeleteRowIndex(null);
    };

    const cancelDelete = () => {
        setShowDeleteConfirm(false);
        setDeleteRowIndex(null);
    };

    const calculateDuration = (startDate, stopDate) => {

        if (!startDate || !stopDate) {
            return '';
        }

        const start = new Date(startDate);
        const end = new Date(stopDate);

        if (end < start) {
            return '';
        }

        const diffTime =
            end.getTime() - start.getTime();

        const diffDays =
            Math.floor(
                diffTime /
                (1000 * 60 * 60 * 24)
            );

        return diffDays;
    };

    // const updateCell = (rowIndex, columnId, cellValue) => {
    //     const newRows = [...rows];
    //     newRows[rowIndex][columnId] = cellValue;
    //     setRows(newRows);
    //     onUpdate({ [question.id]: newRows });

    //     if (rowErrors[rowIndex]?.[columnId]) {
    //         const newErrors = { ...rowErrors };
    //         delete newErrors[rowIndex][columnId];
    //         setRowErrors(newErrors);
    //     }
    // };

    const getDateFields = (row) => {

        const startField = Object.keys(row)
            .find(key => key.endsWith('start_date'));

        const stopField = Object.keys(row)
            .find(key => key.endsWith('stop_date'));

        const ongoingField = Object.keys(row)
            .find(key => key.endsWith('ongoing'));

        const durationField = Object.keys(row)
            .find(key => key.toUpperCase().includes('MDUR'));

        return {
            startField,
            stopField,
            ongoingField,
            durationField
        };
    };



    const updateCell = (
        rowIndex,
        columnId,
        cellValue
    ) => {

        const newRows = [...rows];

        const row = newRows[rowIndex];

        row[columnId] = cellValue;

        const {
            startField,
            stopField,
            ongoingField,
            durationField
        } = getDateFields(row);

        // Ongoing checkbox
        if (
            columnId === ongoingField
        ) {

            if (cellValue === true) {

                row[stopField] = '';
                row[durationField] = '';
            }
        }

        // Auto calculate duration
        if (
            startField &&
            stopField &&
            durationField &&
            !row[ongoingField] &&
            row[startField] &&
            row[stopField]
        ) {

            row[durationField] =
                calculateDuration(
                    row[startField],
                    row[stopField]
                );

        } else if (
            row[ongoingField]
        ) {

            row[durationField] = '';
        }

        setRows(newRows);

        onUpdate({
            [question.id]: newRows
        });

        if (
            rowErrors[rowIndex]?.[columnId]
        ) {

            const newErrors = {
                ...rowErrors
            };

            delete newErrors[rowIndex][columnId];

            setRowErrors(newErrors);
        }
    };



    const shouldShowColumn = (column, row) => {
        if (!column.showIf) return true;

        const { field: conditionField, value: conditionValue } = column.showIf;
        const actualValue = row[conditionField];

        return actualValue === conditionValue;
    };

    const isColumnVisibleInAnyRow = (column) => {
        if (!column.showIf) return true;
        return rows.some(row => shouldShowColumn(column, row));
    };

    const visibleColumns = (question.columns || []).filter(
        column => column && isColumnVisibleInAnyRow(column)
    );

    const renderCell = (row, column, rowIndex) => {
        const cellValue = row[column.id] || '';
        const cellError = rowErrors[rowIndex]?.[column.id];
        const isVisible = shouldShowColumn(column, row);

        const cellStyle = column.width ? { width: `${column.width}px`, minWidth: `${column.width}px` } : {};

        if (!isVisible) {
            return <td key={column.id} className={styles.tableCell} style={cellStyle}></td>;
        }

        switch (column.type) {
            case 'select':
                return (
                    <td key={column.id} className={styles.tableCell} style={cellStyle}>
                        <select
                            value={cellValue}
                            onChange={(e) => updateCell(rowIndex, column.id, e.target.value)}
                            className={`${styles.selectInput} ${cellError ? styles.inputError : ''}`}
                            disabled={isFormDisabled}
                        >
                            <option value="">Select...</option>
                            {column.options.map((option, idx) => (
                                <option key={idx} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                        {cellError && (
                            <span className={styles.cellError}>
                                <AlertCircle size={12} />
                            </span>
                        )}
                    </td>
                );

            case 'checkbox':
            return (
                <td
                    key={column.id}
                    className={styles.tableCell}
                    style={cellStyle}
                >
                    <input
                        type="checkbox"
                        checked={
                            cellValue === true
                        }
                        onChange={(e) =>
                            updateCell(
                                rowIndex,
                                column.id,
                                e.target.checked
                            )
                        }
                        disabled={isFormDisabled}
                    />
                </td>
            );
            case 'date':
            return (
                <td
                    key={column.id}
                    className={styles.tableCell}
                    style={cellStyle}
                >
                    <div style={{ position: 'relative', width: '100%' }}>

                        {/* Visible textbox */}
                        <input
                            type="text"
                            value={
                                cellValue
                                    ? formatDate(cellValue)
                                    : ''
                            }
                            placeholder="DD-MMM-YYYY"
                            readOnly
                            className={styles.textInput}
                            style={{
                                width: '100%'
                            }}
                            onClick={() =>
                                document
                                    .getElementById(
                                        `${column.id}_${rowIndex}`
                                    )
                                    ?.showPicker?.()
                            }
                        />

                        {/* Hidden date picker */}
                        <input
                            id={`${column.id}_${rowIndex}`}
                            type="date"
                            value={cellValue || ''}
                            onChange={(e) =>
                                updateCell(
                                    rowIndex,
                                    column.id,
                                    e.target.value
                                )
                            }
                            disabled={
                                isFormDisabled ||
                                (
                                    column.id.endsWith('stop_date') &&
                                   column.id.endsWith('ongoing')
                                )
                            }
                            style={{
                                position: 'absolute',
                                left: 0,
                                top: 0,
                                width: '100%',
                                height: '100%',
                                opacity: 0,
                                cursor: 'pointer',
                                alignitems: 'center',
                                pointerEvents : 'none'
                            }}
                        />
                    </div>
                </td>
            );
            case 'number':
                return (
                    <td key={column.id} className={styles.tableCell} style={cellStyle}>
                        <input
                            type="text"
                            inputMode="decimal"
                            value={cellValue}
                            onChange={(e) => {
                                const val = e.target.value.replace(/[^\d.]/g, '');
                                const parts = val.split('.');
                                if (parts.length > 2) {
                                    return;
                                }
                                updateCell(rowIndex, column.id, val);
                            }}
                            className={`${styles.textInput} ${cellError ? styles.inputError : ''}`}
                            disabled={
                                isFormDisabled ||
                                column.disabled ||
                                column.id
                                    .toUpperCase()
                                    .includes('MDUR')
                            }
                            placeholder={column.label}
                        />
                        {cellError && (
                            <span className={styles.cellError}>
                                <AlertCircle size={12} />
                            </span>
                        )}
                    </td>
                );

            case 'text':
            default:
                return (
                    <td key={column.id} className={styles.tableCell} style={cellStyle}>
                        <input
                            type="text"
                            value={cellValue}
                            onChange={(e) => updateCell(rowIndex, column.id, e.target.value)}
                            className={`${styles.textInput} ${cellError ? styles.inputError : ''}`}
                            disabled={isFormDisabled}
                            placeholder={column.label}
                        />
                        {cellError && (
                            <span className={styles.cellError}>
                                <AlertCircle size={12} />
                            </span>
                        )}
                    </td>
                );
        }
    };

    if (!shouldShow) return null;

    return (
        <div className={styles.tableWrapper}>
            <div className={styles.tableHeader}>
                {question.label && (
                    <label className={styles.tableLabel}>
                        {question.label}
                        {question.required && <span className={styles.required}>*</span>}
                    </label>
                )}
                {!isFormDisabled && (
                    <button
                        type="button"
                        onClick={addRow}
                        className={styles.addButton}
                        disabled={isFormDisabled}
                    >
                        <Plus size={16} />
                        Add Row
                    </button>
                )}
            </div>

            {rows.length > 0 && (
                <div className={styles.tableContainer}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                {visibleColumns.map((column, idx) => (
                                    <th
                                        key={idx}
                                        className={styles.tableHeaderCell}
                                        style={column.width ? { width: `${column.width}px`, minWidth: `${column.width}px` } : {}}
                                    >
                                        {column.label}
                                        {column.required && <span className={styles.required}>*</span>}
                                    </th>
                                ))}
                                {!isFormDisabled && (
                                    <th className={styles.tableHeaderCell}>Actions</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, rowIndex) => (
                                <tr key={rowIndex} className={styles.tableRow}>
                                    {visibleColumns.map((column) => renderCell(row, column, rowIndex))}
                                    {!isFormDisabled && (
                                        <td className={styles.tableCell}>
                                            <button
                                                type="button"
                                                onClick={() => handleDeleteClick(rowIndex)}
                                                className={styles.deleteButton}
                                                disabled={isFormDisabled}
                                                title="Remove row"
                                            >
                                                <Trash2 size={16} />
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {rows.length === 0 && (
                <div className={styles.emptyState}>
                    <p>No medications added yet. Click "Add Row" to add a medication.</p>
                </div>
            )}

            {error && (
                <span className={styles.errorMessage}>
                    <AlertCircle size={16} />
                    {error}
                </span>
            )}

            {showDeleteConfirm && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <h3 className={styles.modalTitle}>Confirm Delete</h3>
                        <p className={styles.modalMessage}>Are you sure do you want to delete it?</p>
                        <div className={styles.modalActions}>
                            <button
                                type="button"
                                onClick={cancelDelete}
                                className={styles.modalCancelButton}
                            >
                                No
                            </button>
                            <button
                                type="button"
                                onClick={confirmDelete}
                                className={styles.modalConfirmButton}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TableInput;